interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, totalPages: number): number[] {
  const pages: number[] = [];
  const start = Math.max(1, Math.min(page - 2, totalPages - 4));
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = buildPages(page, totalPages);

  const baseBtn =
    "min-w-9 h-9 px-2 flex items-center justify-center rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap";

  return (
    <nav className="flex items-center justify-center gap-2 flex-wrap" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        className={`${baseBtn} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`${baseBtn} ${
            p === page
              ? "bg-primary-600 text-background-50"
              : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700"
          }`}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        className={`${baseBtn} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}